import React from 'react'
import cx from 'classnames'

import CategoriesZone from '@/modules/categoriesZone.js'

import Footer from '@/footer.js'
import META from '@/meta.js'
import ComingSoon from '@/modules/comingSoon.js'
import ThemeProvider from '@/themeProvider.js'
import { queryBrands } from 'utls/queryBrands.js'


const WhatsInStore = ({ transitionStatus, entry, exit }) => {
  const data = queryBrands()
  const {
    title,
    subDescription,
    categories,
    brands,
    stickers
  } = data
  const metaData = {
    title: data.metaInfo ? data.metaInfo.metaTitle || data.title : data.title,
    keywords: data.metaInfo ? data.metaInfo.keywords || '' : '',
    description: data.metaInfo ? data.metaInfo.description || data.description : data.description,
    url: 'whats-in-store',
    image: '',
    ogTitle: data.metaInfo ? data.metaInfo.title || data.title : data.title,
    ogDescription: data.metaInfo ? data.metaInfo.openGraphDescription || data.description : data.description,
    ogImage: data.metaInfo ? data.metaInfo.openImage || '' : '',
    twitterImage: data.metaInfo ? data.metaInfo.twitterImage || '' : '',
    twitterTitle: data.metaInfo ? data.metaInfo.twitterTitle || data.title : data.title,
    twitterDescription: data.metaInfo ? data.metaInfo.twitterDescription || data.description : data.description
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <div className='nav--spacer' />
      <ThemeProvider color={`one`} />
      <div className='container--xl ma p1'>
        <div className='container--m'>
          <h1>{title}</h1>
          <p>{subDescription}</p>
        </div>
      </div>
      <div className='container--xl ma p1 brand__flex f jcb ais fw'>
        <CategoriesZone categories={categories} brands={brands} stickers={stickers} scrollState={entry.state.category} />
      </div>
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default WhatsInStore
